@if (modalData(); as modal) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-confirmation class="w-[500px]" [imageUrl]="'assets/images/icones/valid.png'"
    [title]="'modal.validated_order.title' | translate" [highlightText]="modal.customerName"
    [countdownText]="'modal.validated_order.countdown' | translate: { seconds: countdownSeconds }"
    [buttonLabel]="'modal.validated_order.cancel_button' | translate" (buttonClick)="onModalButtonClick()" />
</div>
}

@if (insufficientBalanceModalOpen()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-insufficient-balance class="w-[500px]" [title]="'modal.insufficient_balance.title' | translate"
    [currentBalanceLabel]="'modal.insufficient_balance.current_balance_label' | translate"
    [currentBalanceAmount]="walletBalance() | formatPrice"
    [requiredAmountLabel]="'modal.insufficient_balance.required_amount_label' | translate"
    [requiredAmountAmount]="order()?.totalPrice ?? 0 | formatPrice"
    [backToSelectionLabel]="'modal.insufficient_balance.back_to_selection' | translate"
    [saveAndBackLabel]="'modal.insufficient_balance.save' | translate"
    [forcePassageLabel]="'modal.insufficient_balance.force_passage' | translate"
    (backToSelectionClick)="onBackToSelection()" (saveAndBackClick)="onSave()" (forcePassageClick)="onForcePassage()" />
</div>
}

@if (forceReasonModalOpen()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-force-reason class="w-[500px]" [title]="'modal.force_reason.title' | translate"
    [subtitle]="'modal.force_reason.subtitle' | translate" [reasonLabel]="'modal.force_reason.reason_label' | translate"
    [reasonPlaceholder]="'modal.force_reason.reason_placeholder' | translate"
    [requiredErrorMessage]="'modal.force_reason.required_error' | translate" [cancelLabel]="'common.cancel' | translate"
    [confirmLabel]="'common.confirm' | translate" (cancelClick)="onCancelForceReason()"
    (confirmClick)="onConfirmForceReason($event)" />
</div>
}

<!-- Panneau gauche : récapitulatif des choix -->
<div class="flex-1 min-w-0 bg-gris-4 rounded-[10px] flex flex-col overflow-hidden m-5">
  <!-- Titre -->
  <p class="text-[20px] font-semibold fg-noir-2 px-5 pt-5 pb-3 shrink-0 leading-none border-b border-gris-3">
    {{ 'order_summary.title' | translate }}
  </p>

  <!-- Liste des plats -->
  <div class="flex-1 overflow-y-auto min-h-0 p-5 flex flex-col gap-5">
    @if ((order()?.items ?? []).length === 0) {
    <div class="flex items-center justify-center py-10">
      <span class="text-[14px] fg-gris-1">{{ 'order_summary.empty' | translate }}</span>
    </div>
    }

    @for (section of sections(); track section.titleKey) {
    <div class="flex flex-col gap-3">
      <p class="text-[14px] font-semibold fg-noir-2 leading-none">
        {{ section.titleKey | translate }}
      </p>
      <div class="grid gap-3 grid-cols-[repeat(auto-fill,minmax(280px,1fr))]">
        @for (item of section.items; track item.course.id) {
        <app-summary-course-card [course]="item.course" [serviceName]="item.part.service_name"
          [showPrice]="section.showPrice" [disabled]="false" [quantity]="item.quantity" [bgColor]="item.bgColor"
          [imageUrl]="item.imageUrl" [showRemoveButton]="false" />
        }
      </div>
    </div>
    }
  </div>
</div>

<!-- Panneau droit : paiement -->
<div class="w-[342px] shrink-0 bg-gris-4 rounded-[10px] flex flex-col overflow-hidden m-5 ml-0">
  <!-- Titre -->
  <p class="text-[20px] font-semibold fg-noir-2 px-5 pt-5 pb-3 shrink-0 leading-none">
    {{ 'order_summary.payment_title' | translate }}
  </p>

  <!-- Séparateur -->
  <div class="h-px bg-gris-3"></div>

  <div class="flex flex-col h-full">
    <!-- Ajoute h-full pour occuper toute la hauteur -->
    <div class="flex-1 px-5 flex flex-col gap-4 pt-4">
      <!-- Mode de paiement -->
      <div class="flex items-center justify-between">
        <span class="text-[16px] font-semibold fg-noir-2">
          {{ 'order_summary.payment_mode_label' | translate }}
        </span>
        <span class="text-[16px] font-semibold fg-gris-1">
          @if (paymentTypeKey()) {
          {{ paymentTypeKey() | translate }}
          } @else {
          {{ 'common.none' | translate }}
          }
        </span>
      </div>

      @if (paymentTypeKey() == 'payment_type.wallet') {
      <!-- Solde actuel -->
      <div class="flex items-center justify-between">
        <span class="text-[16px] font-semibold fg-noir-2">
          {{ 'order_summary.current_balance_label' | translate }}
        </span>
        <span class="text-[16px] font-semibold fg-gris-1">{{
          walletBalance() | formatPrice
          }}</span>
      </div>
      }

      <!-- Total (encadré vert) -->
      <div class="border-2 border-vert-1 rounded-[10px] p-2 flex items-center justify-between bg-white">
        <span class="text-[20px] font-semibold fg-noir-2">
          {{ 'order_summary.total_label' | translate }}
        </span>
        <span class="text-[20px] font-semibold fg-vert-1">
          {{ order()?.totalPrice ?? 0 | formatPrice }}
        </span>
      </div>

      @if (paymentTypeKey() == 'payment_type.wallet') {
      <!-- Solde après débit -->
      <div class="flex items-center justify-between">
        <span class="text-[16px] font-semibold fg-noir-2">
          {{ 'order_summary.balance_after_debit_label' | translate }}
        </span>
        <span class="text-[16px] font-semibold" [class]="balanceColor()">
          {{ balanceAfterDebit() | formatPrice }}
        </span>
      </div>
      }
    </div>

    <!-- Bouton valider la commande (toujours en bas) -->
    <div class="px-5 pb-5 pt-4 shrink-0">
      <button type="button" (click)="confirmOrder()" [disabled]="(order()?.items ?? []).length === 0"
        class="w-full h-[64px] rounded-[5px] text-white text-[16px] font-semibold transition-all"
        [class.bg-vert-1]="(order()?.items ?? []).length > 0" [class.cursor-pointer]="(order()?.items ?? []).length > 0"
        [class.hover:brightness-95]="(order()?.items ?? []).length > 0"
        [class.bg-gris-3]="(order()?.items ?? []).length === 0"
        [class.cursor-not-allowed]="(order()?.items ?? []).length === 0">
        {{ 'order_summary.confirm_button' | translate }}
      </button>
    </div>
  </div>
</div>